import { useState, useEffect } from "react";

const css = `
@import url('https://fonts.googleapis.com/css2?family=Unbounded:wght@300;400;700;900&family=Manrope:wght@300;400;500&display=swap');

*, *::before, *::after { margin: 0; padding: 0; box-sizing: border-box; }

:root {
  --bg:    #060606;
  --bg1:   #0D0D0D;
  --bg2:   #111;
  --green: #0099FF;
  --green2:#B3DFFF;
  --txt:   #F4F4F0;
  --muted: #555;
  --mid:   #2A2A2A;
  --border:rgba(255,255,255,0.06);
}

html { scroll-behavior: smooth; }
body {
  background: var(--bg);
  color: var(--txt);
  font-family: 'Manrope', sans-serif;
  font-weight: 300;
  overflow-x: hidden;
}

/* ─── NAV ─── */
.nav {
  position: fixed; inset: auto 0 auto 0; top: 0; z-index: 200;
  padding: 1.4rem 2.5rem;
  display: flex; align-items: center; justify-content: space-between;
  transition: background .4s, backdrop-filter .4s;
}
.nav.scrolled {
  background: rgba(6,6,6,.88);
  backdrop-filter: blur(20px);
  border-bottom: 1px solid var(--border);
}
.nav-logo {
  font-family: 'Unbounded', sans-serif;
  font-weight: 700; font-size: .95rem; letter-spacing: .01em;
  color: var(--txt); text-decoration: none; display: flex; align-items: center; gap: 10px;
}
.nav-logo-dot {
  width: 8px; height: 8px; border-radius: 50%;
  background: var(--green); animation: blink 2s infinite;
}
.nav-center { display: flex; gap: 2.5rem; list-style: none; }
.nav-center a {
  font-size: .72rem; font-weight: 500; letter-spacing: .1em;
  text-transform: uppercase; color: var(--muted);
  text-decoration: none; transition: color .2s;
}
.nav-center a:hover { color: var(--txt); }
.nav-cta {
  font-family: 'Unbounded', sans-serif;
  font-size: .65rem; font-weight: 700; letter-spacing: .06em;
  text-transform: uppercase; color: var(--bg);
  background: var(--green); padding: .65rem 1.6rem;
  text-decoration: none; border-radius: 2px;
  transition: background .2s, transform .15s;
  white-space: nowrap;
}
.nav-cta:hover { background: var(--green2); transform: scale(1.03); }

/* hamburger */
.nav-burger {
  display: none; flex-direction: column; gap: 4px;
  background: none; border: none; cursor: pointer;
}
.nav-burger span { display: block; width: 22px; height: 1.5px; background: var(--txt); transition: .3s; }
.nav-burger.open span:nth-child(1) { transform: translateY(5.5px) rotate(45deg); }
.nav-burger.open span:nth-child(2) { opacity: 0; }
.nav-burger.open span:nth-child(3) { transform: translateY(-5.5px) rotate(-45deg); }
.mob-menu {
  display: none; position: fixed; inset: 0; z-index: 190;
  background: var(--bg); flex-direction: column;
  align-items: center; justify-content: center; gap: 2rem;
}
.mob-menu.open { display: flex; }
.mob-menu a {
  font-family: 'Unbounded', sans-serif; font-weight: 700;
  font-size: clamp(2rem, 8vw, 3.5rem); color: var(--txt);
  text-decoration: none; transition: color .2s;
}
.mob-menu a:hover { color: var(--green); }

/* ─── HERO ─── */
.hero {
  min-height: 100vh;
  padding: 10rem 2.5rem 4rem;
  display: flex; flex-direction: column;
  justify-content: flex-end; position: relative; overflow: hidden;
}
/* diagonal accent line */
.hero::after {
  content: '';
  position: absolute; top: 0; right: 15%;
  width: 1px; height: 100%;
  background: linear-gradient(to bottom, transparent, var(--green), transparent);
  opacity: .18;
}
.hero-tag {
  display: inline-flex; align-items: center; gap: 8px;
  font-size: .65rem; font-weight: 500; letter-spacing: .14em;
  text-transform: uppercase; color: var(--green);
  margin-bottom: 2rem;
  animation: fadeUp .6s .1s both;
}
.hero-tag-line { width: 28px; height: 1px; background: var(--green); }
.hero-h {
  font-family: 'Unbounded', sans-serif;
  font-weight: 900;
  font-size: clamp(3.2rem, 9.5vw, 11rem);
  line-height: .88; letter-spacing: -.03em;
  margin-bottom: 4rem;
  text-transform: uppercase;
}
.hero-h .row { display: block; overflow: hidden; }
.hero-h .row-inner {
  display: block;
  animation: slideUp .9s cubic-bezier(.16,1,.3,1) both;
}
.hero-h .row:nth-child(1) .row-inner { animation-delay: .15s; }
.hero-h .row:nth-child(2) .row-inner { animation-delay: .28s; }
.hero-h .row:nth-child(3) .row-inner { animation-delay: .41s; }
.hero-h .g { color: var(--green); }
.hero-h .ol {
  -webkit-text-stroke: 1.5px rgba(244,244,240,.15);
  color: transparent;
}
.hero-foot {
  display: flex; align-items: flex-end;
  justify-content: space-between; gap: 2rem;
  animation: fadeUp .7s .75s both;
}
.hero-desc {
  max-width: 380px; font-size: 1.05rem;
  color: var(--muted); line-height: 1.75;
}
.hero-desc b { color: var(--txt); font-weight: 400; }
.hero-actions { display: flex; gap: 1rem; flex-wrap: wrap; align-items: center; }
.btn-main {
  font-family: 'Unbounded', sans-serif;
  font-size: .7rem; font-weight: 700; letter-spacing: .06em;
  text-transform: uppercase; color: var(--bg);
  background: var(--green); padding: 1rem 2.4rem;
  text-decoration: none; border-radius: 2px;
  display: inline-block; transition: transform .2s, box-shadow .2s;
}
.btn-main:hover { transform: translateY(-3px); box-shadow: 0 12px 30px rgba(0,153,255,.2); }
.btn-ghost {
  font-family: 'Unbounded', sans-serif;
  font-size: .7rem; font-weight: 400; letter-spacing: .06em;
  text-transform: uppercase; color: var(--muted);
  border: 1px solid var(--mid); padding: 1rem 2rem;
  text-decoration: none; border-radius: 2px;
  display: inline-block; transition: color .2s, border-color .2s;
}
.btn-ghost:hover { color: var(--txt); border-color: rgba(255,255,255,.2); }
.hero-scroll-wrap {
  position: absolute; bottom: 2.5rem; left: 50%;
  transform: translateX(-50%);
  display: flex; flex-direction: column; align-items: center; gap: 6px;
  animation: fadeUp .7s 1.1s both;
}
.hero-scroll-bar {
  width: 1px; height: 50px;
  background: linear-gradient(to bottom, transparent, var(--green));
  animation: scrollBlink 2s infinite;
}
.hero-scroll-lbl {
  font-size: .55rem; font-weight: 500; letter-spacing: .2em;
  text-transform: uppercase; color: var(--muted);
}
/* floating stats */
.hero-stats {
  position: absolute; top: 50%; right: 3rem;
  transform: translateY(-50%);
  display: flex; flex-direction: column; gap: 2rem;
  animation: fadeUp .7s .9s both;
}
.hero-stat { text-align: right; }
.hero-stat-val {
  font-family: 'Unbounded', sans-serif;
  font-size: 2rem; font-weight: 900; line-height: 1;
  color: var(--txt);
}
.hero-stat-val span { color: var(--green); }
.hero-stat-lbl {
  font-size: .6rem; font-weight: 500; letter-spacing: .12em;
  text-transform: uppercase; color: var(--muted); margin-top: 3px;
}

/* ─── MARQUEE ─── */
.mq-wrap {
  overflow: hidden;
  border-top: 1px solid var(--border);
  border-bottom: 1px solid var(--border);
  padding: 1rem 0; background: var(--bg1);
}
.mq-track { display: flex; white-space: nowrap; animation: mq 25s linear infinite; }
.mq-item {
  font-family: 'Unbounded', sans-serif;
  font-size: .6rem; font-weight: 700; letter-spacing: .16em;
  text-transform: uppercase; color: var(--muted);
  padding: 0 2rem; flex-shrink: 0;
  display: flex; align-items: center; gap: 2rem;
}
.mq-sep { width: 5px; height: 5px; border-radius: 50%; background: var(--green); }

/* ─── SECTION ─── */
.section { padding: 7rem 2.5rem; border-bottom: 1px solid var(--border); }
.sec-eyebrow {
  display: flex; align-items: center; gap: 12px;
  font-size: .65rem; font-weight: 500; letter-spacing: .16em;
  text-transform: uppercase; color: var(--green);
  margin-bottom: 3.5rem;
}
.sec-eyebrow-num {
  font-family: 'Unbounded', sans-serif; font-weight: 700;
  font-size: .6rem; color: var(--bg); background: var(--green);
  padding: 2px 7px; border-radius: 2px;
}
.sec-title {
  font-family: 'Unbounded', sans-serif;
  font-weight: 900; text-transform: uppercase;
  font-size: clamp(2.2rem, 5.5vw, 5.5rem);
  line-height: .92; letter-spacing: -.03em;
}
.sec-title .g { color: var(--green); }

/* ─── PROCESS ─── */
.proc-grid {
  display: grid; grid-template-columns: repeat(3, 1fr);
  gap: 1px; background: var(--border); margin-top: 4rem;
}
.proc-card {
  background: var(--bg1); padding: 2.5rem;
  position: relative; overflow: hidden;
  transition: background .3s;
}
.proc-card:hover { background: var(--bg2); }
.proc-card::before {
  content: '';
  position: absolute; bottom: 0; left: 0; right: 0;
  height: 2px; background: var(--green);
  transform: scaleX(0); transform-origin: left;
  transition: transform .5s cubic-bezier(.16,1,.3,1);
}
.proc-card:hover::before { transform: scaleX(1); }
.proc-big-num {
  font-family: 'Unbounded', sans-serif;
  font-weight: 900; font-size: 5rem;
  color: rgba(0,153,255,.06); line-height: 1;
  margin-bottom: 1.5rem; user-select: none;
}
.proc-title {
  font-family: 'Unbounded', sans-serif;
  font-weight: 700; font-size: 1rem;
  text-transform: uppercase; letter-spacing: -.01em;
  margin-bottom: 1rem;
}
.proc-desc { font-size: .88rem; color: var(--muted); line-height: 1.75; }

/* ─── WORK ─── */
.work-grid {
  margin-top: 4rem;
  display: grid; grid-template-columns: repeat(2, 1fr);
  gap: 1.5rem;
}
.work-card {
  position: relative; border: 1px solid var(--border);
  border-radius: 4px; overflow: hidden; cursor: pointer;
  background: var(--bg1);
  transition: border-color .35s, transform .35s cubic-bezier(.16,1,.3,1);
}
.work-card:hover { border-color: rgba(0,153,255,.35); transform: translateY(-5px); }
.work-card-thumb {
  height: 200px; position: relative;
  display: flex; flex-direction: column;
  justify-content: flex-end; padding: 1.5rem;
}
.work-card-thumb::after {
  content: '';
  position: absolute; inset: 0;
  background: linear-gradient(to bottom, transparent 30%, rgba(0,0,0,.72));
}
.work-card-idx {
  position: absolute; top: 1.2rem; left: 1.5rem; z-index: 1;
  font-family: 'Unbounded', sans-serif;
  font-size: .52rem; font-weight: 700; letter-spacing: .14em;
  text-transform: uppercase; color: rgba(255,255,255,.45);
}
.work-card-arrow {
  position: absolute; top: 1.1rem; right: 1.4rem; z-index: 1;
  width: 32px; height: 32px; border-radius: 50%;
  background: rgba(0,153,255,.15); border: 1px solid rgba(0,153,255,.3);
  display: flex; align-items: center; justify-content: center;
  font-size: .8rem; color: var(--green);
  opacity: 0; transform: scale(.8);
  transition: opacity .3s, transform .3s;
}
.work-card:hover .work-card-arrow { opacity: 1; transform: scale(1); }
.work-card-title {
  position: relative; z-index: 1;
  font-family: 'Unbounded', sans-serif;
  font-weight: 900; font-size: clamp(1.3rem, 2.2vw, 1.9rem);
  text-transform: uppercase; letter-spacing: -.025em;
  color: #fff; line-height: 1; margin-bottom: .35rem;
}
.work-card-sub-over {
  position: relative; z-index: 1;
  font-size: .7rem; color: rgba(255,255,255,.5);
  letter-spacing: .04em;
}
.work-card-body { padding: 1.2rem 1.5rem 1.5rem; }
.work-card-divider {
  height: 1px; background: var(--border); margin-bottom: 1.2rem;
}
.work-card-tags { display: flex; gap: .5rem; flex-wrap: wrap; }
.w-tag {
  font-size: .55rem; font-weight: 500; letter-spacing: .1em;
  text-transform: uppercase; color: var(--green);
  border: 1px solid rgba(0,153,255,.2); padding: 3px 9px;
  border-radius: 2px;
}

/* ─── TESTIMONIALS ─── */
.testi-grid {
  margin-top: 4rem;
  display: grid; grid-template-columns: repeat(3, 1fr);
  gap: 1.5rem;
}
.t-card {
  background: var(--bg1); padding: 2.2rem;
  border: 1px solid var(--border); border-radius: 4px;
  transition: border-color .3s;
}
.t-card:hover { border-color: rgba(0,153,255,.2); }
.t-stars {
  display: flex; gap: 3px; margin-bottom: 1.2rem;
}
.t-star {
  width: 10px; height: 10px; background: var(--green);
  clip-path: polygon(50% 0%,61% 35%,98% 35%,68% 57%,79% 91%,50% 70%,21% 91%,32% 57%,2% 35%,39% 35%);
}
.t-quote {
  font-size: .95rem; color: var(--txt); line-height: 1.75;
  margin-bottom: 1.8rem; font-weight: 300;
}
.t-author { display: flex; align-items: center; gap: 12px; }
.t-av {
  width: 36px; height: 36px; border-radius: 50%;
  background: var(--green); display: flex; align-items: center;
  justify-content: center; font-family: 'Unbounded', sans-serif;
  font-weight: 700; font-size: .55rem; color: var(--bg);
  flex-shrink: 0;
}
.t-name { font-size: .82rem; font-weight: 500; color: var(--txt); }
.t-biz { font-size: .72rem; color: var(--muted); margin-top: 2px; }

/* ─── SERVICES ─── */
.svc-grid {
  margin-top: 4rem;
  display: grid; grid-template-columns: repeat(3, 1fr);
  gap: 1px; background: var(--border);
}
.svc {
  background: var(--bg1); padding: 2.5rem;
  position: relative; overflow: hidden;
  transition: background .3s;
}
.svc:hover { background: var(--bg2); }
.svc-idx {
  font-family: 'Unbounded', sans-serif;
  font-size: .55rem; font-weight: 700; color: var(--green);
  letter-spacing: .12em; text-transform: uppercase;
  margin-bottom: 1.5rem; display: block;
}
.svc-title {
  font-family: 'Unbounded', sans-serif;
  font-weight: 700; font-size: 1rem;
  text-transform: uppercase; letter-spacing: -.01em;
  margin-bottom: 1rem;
}
.svc-desc { font-size: .86rem; color: var(--muted); line-height: 1.75; margin-bottom: 1.5rem; }
.svc-price {
  font-family: 'Unbounded', sans-serif;
  font-size: .7rem; font-weight: 700;
  color: var(--green); letter-spacing: .04em;
}

/* ─── ABOUT ─── */
.about-grid {
  display: grid; grid-template-columns: 1fr 1fr;
  gap: 5rem; align-items: center;
}
.about-left {
  position: relative; aspect-ratio: 1;
  background: var(--bg1);
  border: 1px solid var(--border);
  display: flex; align-items: center; justify-content: center;
  overflow: hidden;
}
.about-left::before {
  content: 'DC';
  font-family: 'Unbounded', sans-serif;
  font-weight: 900; font-size: 14rem;
  color: rgba(0,153,255,.04); position: absolute;
  user-select: none; line-height: 1;
}
.about-avatar-wrap { position: relative; z-index: 1; text-align: center; }
.about-av {
  width: 110px; height: 110px; border-radius: 50%;
  background: var(--green); display: flex; align-items: center;
  justify-content: center; margin: 0 auto 1rem;
  font-family: 'Unbounded', sans-serif;
  font-weight: 900; font-size: 2.5rem; color: var(--bg);
}
.about-name {
  font-family: 'Unbounded', sans-serif;
  font-weight: 700; font-size: 1rem; text-transform: uppercase;
  letter-spacing: -.01em;
}
.about-role-tag {
  font-size: .65rem; font-weight: 500; letter-spacing: .14em;
  text-transform: uppercase; color: var(--green); margin-top: 4px;
}
.about-stats-bar {
  position: absolute; bottom: 0; left: 0; right: 0;
  display: grid; grid-template-columns: 1fr 1fr 1fr;
  border-top: 1px solid var(--border);
}
.ab-stat { padding: 1rem; text-align: center; border-right: 1px solid var(--border); }
.ab-stat:last-child { border-right: none; }
.ab-val {
  font-family: 'Unbounded', sans-serif;
  font-weight: 900; font-size: 1.4rem; color: var(--green);
}
.ab-lbl {
  font-size: .55rem; font-weight: 500; letter-spacing: .1em;
  text-transform: uppercase; color: var(--muted); margin-top: 3px;
}
.about-right {}
.about-h {
  font-family: 'Unbounded', sans-serif;
  font-weight: 900; font-size: clamp(1.8rem, 3.5vw, 3.2rem);
  text-transform: uppercase; letter-spacing: -.03em;
  line-height: .95; margin-bottom: 2rem;
}
.about-h .g { color: var(--green); }
.about-p { font-size: .95rem; color: var(--muted); line-height: 1.8; margin-bottom: 1rem; }
.about-checks { margin: 2rem 0; display: flex; flex-direction: column; gap: .9rem; }
.ab-check { display: flex; align-items: flex-start; gap: .9rem; font-size: .88rem; color: var(--muted); }
.ab-check-icon {
  width: 18px; height: 18px; background: rgba(0,153,255,.1);
  border: 1px solid rgba(0,153,255,.25);
  display: flex; align-items: center; justify-content: center;
  flex-shrink: 0; margin-top: 1px; font-size: .6rem; color: var(--green);
  border-radius: 2px;
}

/* ─── CTA ─── */
.cta-section {
  padding: 9rem 2.5rem;
  text-align: center; position: relative; overflow: hidden;
}
.cta-section::before {
  content: '';
  position: absolute; inset: 0;
  background: radial-gradient(ellipse 55% 60% at 50% 50%, rgba(0,153,255,.07), transparent);
  pointer-events: none;
}
.cta-h {
  font-family: 'Unbounded', sans-serif;
  font-weight: 900; font-size: clamp(2.5rem, 7vw, 7.5rem);
  text-transform: uppercase; letter-spacing: -.04em;
  line-height: .88; margin-bottom: 3rem;
}
.cta-h .g { color: var(--green); }
.cta-sub {
  font-size: 1rem; color: var(--muted); margin-bottom: 2.5rem;
  line-height: 1.7; max-width: 480px; margin-left: auto; margin-right: auto;
}
.cta-email {
  font-family: 'Unbounded', sans-serif;
  font-size: .75rem; letter-spacing: .06em;
  color: var(--green); margin-bottom: 2.5rem; display: block;
  text-decoration: none; transition: opacity .2s;
}
.cta-email:hover { opacity: .7; }
.cta-btns { display: flex; gap: 1rem; justify-content: center; flex-wrap: wrap; }

/* ─── FOOTER ─── */
.footer {
  background: var(--bg1); border-top: 1px solid var(--border);
  padding: 2.5rem; display: flex;
  align-items: center; justify-content: space-between;
  flex-wrap: wrap; gap: 1.5rem;
}
.f-logo {
  font-family: 'Unbounded', sans-serif;
  font-weight: 900; font-size: .9rem;
  letter-spacing: -.01em; color: var(--txt);
  display: flex; align-items: center; gap: 8px;
}
.f-logo-dot { width: 7px; height: 7px; border-radius: 50%; background: var(--green); }
.f-links { display: flex; gap: 2rem; list-style: none; flex-wrap: wrap; }
.f-links a {
  font-size: .65rem; font-weight: 500; letter-spacing: .1em;
  text-transform: uppercase; color: var(--muted);
  text-decoration: none; transition: color .2s;
}
.f-links a:hover { color: var(--green); }
.f-mail {
  font-family: 'Unbounded', sans-serif;
  font-size: .65rem; font-weight: 700; letter-spacing: .06em;
  color: var(--green); text-decoration: none;
  display: flex; align-items: center; gap: 7px;
  transition: opacity .2s;
}
.f-mail::before {
  content: '✉';
  font-size: .7rem;
}
.f-mail:hover { opacity: .7; }
.f-copy {
  font-size: .62rem; font-weight: 500; letter-spacing: .1em;
  text-transform: uppercase; color: var(--muted);
}

/* ─── MOBILE HERO STATS STRIP ─── */
.hero-stats-mob {
  display: none;
  border: 1px solid var(--border); border-radius: 4px;
  overflow: hidden; margin-bottom: 2.5rem;
}
.hero-stat-mob {
  flex: 1; padding: .9rem .5rem; text-align: center;
  border-right: 1px solid var(--border);
}
.hero-stat-mob:last-child { border-right: none; }
.hero-stat-mob-val {
  font-family: 'Unbounded', sans-serif;
  font-weight: 900; font-size: 1.15rem; color: var(--txt); line-height: 1;
}
.hero-stat-mob-val span { color: var(--green); }
.hero-stat-mob-lbl {
  font-size: .48rem; font-weight: 500; letter-spacing: .1em;
  text-transform: uppercase; color: var(--muted); margin-top: 5px;
}

/* ─── STICKY MOBILE CTA BAR ─── */
.mob-cta-bar {
  display: none; position: fixed; bottom: 0; left: 0; right: 0; z-index: 300;
  padding: .75rem 1.25rem calc(.75rem + env(safe-area-inset-bottom));
  background: rgba(6,6,6,.96); backdrop-filter: blur(20px);
  border-top: 1px solid var(--border);
}
.mob-cta-btn {
  display: block; width: 100%;
  font-family: 'Unbounded', sans-serif;
  font-size: .7rem; font-weight: 700; letter-spacing: .06em;
  text-transform: uppercase; color: var(--bg);
  background: var(--green); padding: 1rem;
  text-decoration: none; border-radius: 2px;
  text-align: center; transition: background .2s;
}
.mob-cta-btn:hover { background: var(--green2); }

/* ─── ANIMATIONS ─── */
@keyframes fadeUp { from { opacity:0; transform:translateY(14px); } to { opacity:1; transform:translateY(0); } }
@keyframes slideUp { from { transform:translateY(105%); } to { transform:translateY(0); } }
@keyframes mq { from { transform:translateX(0); } to { transform:translateX(-50%); } }
@keyframes blink { 0%,100% { opacity:1; } 50% { opacity:.3; } }
@keyframes scrollBlink { 0%,100% { opacity:.3; } 50% { opacity:1; } }

/* ─── RESPONSIVE ─── */
@media (max-width: 1100px) {
  .hero-stats { display: none; }
}
@media (max-width: 900px) {
  .proc-grid { grid-template-columns: 1fr; }
  .svc-grid { grid-template-columns: 1fr; }
  .testi-grid { grid-template-columns: 1fr; }
  .about-grid { grid-template-columns: 1fr; gap: 3rem; }
  .about-left { aspect-ratio: 4/3; }
}
@media (max-width: 768px) {
  /* Nav */
  .nav { padding: 1.1rem 1.25rem; }
  .nav-center, .nav-cta { display: none; }
  .nav-burger { display: flex; }

  /* Mobile menu */
  .mob-menu { gap: 1.6rem; }
  .mob-menu-email {
    font-size: .75rem; font-weight: 500; letter-spacing: .06em;
    color: var(--muted); text-decoration: none; transition: color .2s;
    margin-top: .5rem;
  }
  .mob-menu-email:hover { color: var(--green); }

  /* Hero */
  .hero { padding: 7rem 1.25rem 5.5rem; }
  .hero::after { display: none; }
  .hero-tag { margin-bottom: 1.5rem; }
  .hero-stats-mob { display: flex; }
  .hero-foot { flex-direction: column; align-items: flex-start; gap: 1.5rem; }
  .hero-scroll-wrap { display: none; }

  /* Hero actions full-width on mobile */
  .hero-actions { width: 100%; flex-direction: column; gap: .75rem; }
  .hero-actions .btn-main,
  .hero-actions .btn-ghost { text-align: center; padding: 1.1rem; }

  /* Sections */
  .section { padding: 4rem 1.25rem; }

  /* Process */
  .proc-card { padding: 2rem 1.25rem; }
  .proc-big-num { font-size: 3.5rem; margin-bottom: 1rem; }
  .proc-grid { gap: 1px; }

  /* Work */
  .work-grid { grid-template-columns: 1fr; gap: 1rem; }
  .work-card-thumb { height: 180px; }
  .work-card-body { padding: 1rem 1.25rem 1.25rem; }

  /* Testimonials */
  .testi-grid { gap: 1rem; }
  .t-card { padding: 1.6rem 1.25rem; }

  /* Services */
  .svc { padding: 1.8rem 1.25rem; }
  .svc-grid { gap: 1px; }

  /* About */
  .about-left { aspect-ratio: unset; min-height: 220px; padding-bottom: 85px; }
  .about-stats-bar { grid-template-columns: 1fr 1fr; }
  .about-stats-bar .ab-stat:last-child { border-right: none; border-top: 1px solid var(--border); grid-column: 1/-1; }
  .ab-stat { padding: .75rem; }

  /* CTA */
  .cta-section { padding: 5rem 1.25rem 5.5rem; }
  .cta-h { margin-bottom: 2rem; }
  .cta-btns { flex-direction: column; align-items: stretch; gap: .75rem; }
  .cta-btns .btn-main,
  .cta-btns .btn-ghost { text-align: center; padding: 1.1rem; }

  /* Footer — extra bottom padding for sticky bar */
  .footer { padding: 2rem 1.25rem 6rem; flex-direction: column; align-items: flex-start; gap: 1.2rem; }

  /* Show sticky bar */
  .mob-cta-bar { display: block; }
}
@media (max-width: 480px) {
  .hero { padding: 6.5rem 1.25rem 5.5rem; }
  .hero-h { font-size: clamp(2.8rem, 12vw, 4.2rem); }
  .hero-desc { font-size: .95rem; }
  .sec-title { font-size: clamp(2rem, 9vw, 3rem); }
  .work-card-thumb { height: 160px; }
  .work-card-title { font-size: clamp(1.2rem, 5.5vw, 1.6rem); }
}
`;

const works = [
  { idx:"01", title:"Ember & Oak", sub:"Restaurant & Bar · London · 2024", tags:["Branding","Web Design","SEO"], bg:"linear-gradient(135deg,#1C0804,#7A2810)" },
  { idx:"02", title:"Bloom Studio", sub:"Beauty & Wellness · Hackney · 2024", tags:["Booking System","Web Design"], bg:"linear-gradient(135deg,#08040E,#3A1870)" },
  { idx:"03", title:"Craft & Co.", sub:"Independent Brewery · Bermondsey · 2024", tags:["E-Commerce","Web Design"], bg:"linear-gradient(135deg,#040E06,#0E5020)" },
  { idx:"04", title:"Harlow & Sons", sub:"Law Practice · City of London · 2025", tags:["Branding","Web Design","CMS"], bg:"linear-gradient(135deg,#04080E,#102050)" },
];

const testimonials = [
  { quote:"Dan completely transformed our online presence. We went from barely any bookings to it being our main source of new customers.", name:"Sarah M.", biz:"Bloom Studio, Hackney", initials:"SM" },
  { quote:"Finally a website that looks like us. He took the time to understand the business before touching a design tool. Genuinely impressive.", name:"James & Priya H.", biz:"Ember & Oak, Shoreditch", initials:"JP" },
  { quote:"Two weeks, fixed price, zero stress. My new site was live before I expected it and the enquiries started the same week.", name:"Tom C.", biz:"Craft & Co. Brewery, Bermondsey", initials:"TC" },
];

export default function DanCreative() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const h = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", h);
    return () => window.removeEventListener("scroll", h);
  }, []);

  const mq = ["Web Design","Brand Identity","SEO","E-Commerce","Booking Systems","Custom CMS","UX Design","Web Design","Brand Identity","SEO","E-Commerce","Booking Systems","Custom CMS","UX Design"];

  return (
    <>
      <style>{css}</style>

      {/* Mobile menu */}
      <div className={`mob-menu${open ? " open" : ""}`}>
        {["Work","Services","About","Contact"].map(l=>(
          <a key={l} href={`#${l.toLowerCase()}`} onClick={()=>setOpen(false)}>{l}</a>
        ))}
        <a href="mailto:hello@dancreative.co.uk" className="mob-menu-email" onClick={()=>setOpen(false)}>hello@dancreative.co.uk</a>
      </div>

      {/* NAV */}
      <nav className={`nav${scrolled?" scrolled":""}`}>
        <a href="/" className="nav-logo">
          <span className="nav-logo-dot"/><span>DAN CREATIVE</span>
        </a>
        <ul className="nav-center">
          {["Work","Services","About"].map(l=>(
            <li key={l}><a href={`#${l.toLowerCase()}`}>{l}</a></li>
          ))}
        </ul>
        <div style={{display:"flex",alignItems:"center",gap:"1rem"}}>
          <a href="#contact" className="nav-cta">Let's Talk</a>
          <button className={`nav-burger${open?" open":""}`} onClick={()=>setOpen(o=>!o)} aria-label="Menu">
            <span/><span/><span/>
          </button>
        </div>
      </nav>

      {/* HERO */}
      <section className="hero">
        <div className="hero-stats">
          <div className="hero-stat"><div className="hero-stat-val">30<span>+</span></div><div className="hero-stat-lbl">Projects Done</div></div>
          <div className="hero-stat"><div className="hero-stat-val"><span>5</span>.0</div><div className="hero-stat-lbl">Avg Rating</div></div>
          <div className="hero-stat"><div className="hero-stat-val"><span>2</span>wk</div><div className="hero-stat-lbl">Turnaround</div></div>
        </div>

        <div className="hero-tag"><span className="hero-tag-line"/>Gloucestershire-Based Web Designer · Available Now</div>

        <div className="hero-stats-mob">
          <div className="hero-stat-mob"><div className="hero-stat-mob-val">30<span>+</span></div><div className="hero-stat-mob-lbl">Projects</div></div>
          <div className="hero-stat-mob"><div className="hero-stat-mob-val"><span>5</span>.0</div><div className="hero-stat-mob-lbl">Rating</div></div>
          <div className="hero-stat-mob"><div className="hero-stat-mob-val"><span>2</span>wk</div><div className="hero-stat-mob-lbl">Turnaround</div></div>
        </div>

        <h1 className="hero-h">
          <span className="row"><span className="row-inner">We Build</span></span>
          <span className="row"><span className="row-inner"><span className="g">Websites</span></span></span>
          <span className="row"><span className="row-inner ol">That Work.</span></span>
        </h1>

        <div className="hero-foot">
          <p className="hero-desc">
            <b>Hi, I'm Dan.</b> I create bespoke websites & brand identities for businesses across Gloucestershire and beyond. Custom-built, fast, and designed to grow your customer base.
          </p>
          <div className="hero-actions">
            <a href="#contact" className="btn-main">Start a Project →</a>
            <a href="#work" className="btn-ghost">See Work</a>
          </div>
        </div>

        <div className="hero-scroll-wrap">
          <div className="hero-scroll-bar"/>
          <span className="hero-scroll-lbl">Scroll</span>
        </div>
      </section>

      {/* MARQUEE */}
      <div className="mq-wrap">
        <div className="mq-track">
          {[...mq,...mq].map((item,i)=>(
            <span key={i} className="mq-item"><span className="mq-sep"/>{item}</span>
          ))}
        </div>
      </div>

      {/* PROCESS */}
      <section className="section" id="services">
        <div className="sec-eyebrow"><span className="sec-eyebrow-num">01</span>How It Works</div>
        <h2 className="sec-title">Simple.<br/>Fast. <span className="g">Yours.</span></h2>
        <div className="proc-grid">
          {[
            { n:"01", title:"We Chat", desc:"A relaxed 30-minute call. You tell me what you need, I tell you honestly what I'd build. No pitch. No pressure." },
            { n:"02", title:"I Build It", desc:"Completely bespoke — no page builders, no templates. First draft within a week. Changes until you love it. Fixed price, always." },
            { n:"03", title:"You Go Live", desc:"Fast, mobile-first, and set up to rank on Google. I stay available after launch — you're never left to figure it out alone." },
          ].map(p=>(
            <div className="proc-card" key={p.n}>
              <div className="proc-big-num">{p.n}</div>
              <div className="proc-title">{p.title}</div>
              <p className="proc-desc">{p.desc}</p>
            </div>
          ))}
        </div>
      </section>

      {/* WORK */}
      <section className="section" id="work">
        <div className="sec-eyebrow"><span className="sec-eyebrow-num">02</span>Selected Work</div>
        <h2 className="sec-title">Recent <span className="g">Projects</span></h2>
        <div className="work-grid">
          {works.map(w=>(
            <div className="work-card" key={w.idx}>
              <div className="work-card-thumb" style={{background:w.bg}}>
                <span className="work-card-idx">{w.idx}</span>
                <span className="work-card-arrow">↗</span>
                <div className="work-card-title">{w.title}</div>
                <div className="work-card-sub-over">{w.sub}</div>
              </div>
              <div className="work-card-body">
                <div className="work-card-divider"/>
                <div className="work-card-tags">
                  {w.tags.map(t=><span key={t} className="w-tag">{t}</span>)}
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* TESTIMONIALS */}
      <section className="section">
        <div className="sec-eyebrow"><span className="sec-eyebrow-num">03</span>Kind Words</div>
        <h2 className="sec-title">What Clients <span className="g">Say</span></h2>
        <div className="testi-grid">
          {testimonials.map(t=>(
            <div className="t-card" key={t.name}>
              <div className="t-stars">{[...Array(5)].map((_,i)=><div key={i} className="t-star"/>)}</div>
              <p className="t-quote">"{t.quote}"</p>
              <div className="t-author">
                <div className="t-av">{t.initials}</div>
                <div>
                  <div className="t-name">{t.name}</div>
                  <div className="t-biz">{t.biz}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* SERVICES */}
      <section className="section">
        <div className="sec-eyebrow"><span className="sec-eyebrow-num">04</span>Services</div>
        <h2 className="sec-title">What I <span className="g">Offer</span></h2>
        <div className="svc-grid">
          {[
            { idx:"01", title:"Website Design & Build", desc:"Custom-built, mobile-first sites that are fast, accessible, and designed to convert. Delivered in 2 weeks flat.", price:"From £799" },
            { idx:"02", title:"Brand Identity", desc:"Logo, colour palette, typography — a full visual identity that makes your business look professional and memorable.", price:"From £399" },
            { idx:"03", title:"Local SEO", desc:"Get found on Google by customers in your area. Ongoing optimisation for your location and services.", price:"From £249/mo" },
          ].map(s=>(
            <div className="svc" key={s.idx}>
              <span className="svc-idx">{s.idx}</span>
              <div className="svc-title">{s.title}</div>
              <p className="svc-desc">{s.desc}</p>
              <div className="svc-price">{s.price}</div>
            </div>
          ))}
        </div>
      </section>

      {/* ABOUT */}
      <section className="section" id="about">
        <div className="sec-eyebrow"><span className="sec-eyebrow-num">05</span>About</div>
        <div className="about-grid">
          <div className="about-left">
            <div className="about-avatar-wrap">
              <div className="about-av">D</div>
              <div className="about-name">Dan Vine</div>
              <div className="about-role-tag">Front-End Developer · Gloucestershire</div>
            </div>
            <div className="about-stats-bar">
              <div className="ab-stat"><div className="ab-val">30+</div><div className="ab-lbl">Projects</div></div>
              <div className="ab-stat"><div className="ab-val">100%</div><div className="ab-lbl">Custom Built</div></div>
              <div className="ab-stat"><div className="ab-val">★ 5.0</div><div className="ab-lbl">Rating</div></div>
            </div>
          </div>
          <div className="about-right">
            <h2 className="about-h">Built on<br/><span className="g">Honest</span><br/>Work.</h2>
            <p className="about-p">I started Dan Creative after seeing too many great local businesses lose out to competitors with slicker sites — not better products. That bothered me, so I set out to fix it.</p>
            <p className="about-p">I work directly with every client. No account managers, no outsourcing. You get me from the first call to launch day, and beyond.</p>
            <div className="about-checks">
              {[
                "Zero templates — everything is designed from scratch",
                "Fixed price quotes — no surprises on your invoice",
                "Reply within one working day, every time",
                "Available after launch — you're not on your own",
              ].map(c=>(
                <div className="ab-check" key={c}>
                  <span className="ab-check-icon">✓</span>{c}
                </div>
              ))}
            </div>
            <a href="#contact" className="btn-main" style={{display:"inline-block",marginTop:".5rem"}}>Work With Me →</a>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="cta-section" id="contact">
        <h2 className="cta-h">Let's Build<br/>Something <span className="g">Great.</span></h2>
        <p className="cta-sub">Tell me about your project and I'll get back to you within one working day. No pitch, no pressure — just an honest conversation.</p>
        <a href="mailto:hello@dancreative.co.uk" className="cta-email">hello@dancreative.co.uk</a>
        <div className="cta-btns">
          <a href="mailto:hello@dancreative.co.uk" className="btn-main">Start a Project →</a>
          <a href="mailto:hello@dancreative.co.uk" className="btn-ghost">Send an Email</a>
        </div>
      </section>

      {/* FOOTER */}
      <footer className="footer">
        <div className="f-logo"><span className="f-logo-dot"/>DAN CREATIVE</div>
        <ul className="f-links">
          {["Instagram","LinkedIn","Twitter"].map(l=><li key={l}><a href="/">{l}</a></li>)}
        </ul>
        <a href="mailto:hello@dancreative.co.uk" className="f-mail">hello@dancreative.co.uk</a>
        <span className="f-copy">© 2025 Dan Creative · Gloucestershire</span>
      </footer>

      {/* STICKY MOBILE CTA */}
      <div className="mob-cta-bar">
        <a href="mailto:hello@dancreative.co.uk" className="mob-cta-btn">Email Me →</a>
      </div>
    </>
  );
}
